import React, { MouseEventHandler } from 'react';
import styled from "@emotion/styled";
import { IconPhoneCall } from 'kompare-ui-library';
import { colors } from 'src/theme';
import { i18n } from 'src/common';
import { Button, Flex, Text } from 'src/components';
import { Card } from './card';

const CardStyle = styled(Card)({
  borderWidth: 1,
  borderStyle: 'dashed',
  borderColor: colors.border3,

  '&:hover': {
    borderColor: colors.primary
  }
})

const TextStyle = styled(Text)({
  marginLeft: '28px',
})

export interface RequestAgentCardProps {
  icon?: React.JSX.Element;
  title?: string;
  text?: string;
  buttonLabel?: string;
  onButtonClick?: MouseEventHandler<HTMLButtonElement>;
}

export const RequestAgentCard: React.FC<RequestAgentCardProps> = ({
  icon = <IconPhoneCall color={colors.icon2} width={16} height={16} />,
  title = i18n.t('components.cards.requestAgentCard.title'),
  text = i18n.t('components.cards.requestAgentCard.text'),
  buttonLabel = i18n.t('components.cards.requestAgentCard.buttonLabel'),
  onButtonClick = () => console.log('click')
}) => (
  <CardStyle radius={12} padding={16} background='transparent'>
    <Flex vertical gap={16}>
      <div>
        <Flex gap={12} align='center'>
          {icon}
          <Text type='base' bold>{title}</Text>
        </Flex>
        <TextStyle type="tiny">{text}</TextStyle>
      </div>
      <Button btnType="outlinePrimary" size="large" text={buttonLabel} onClick={(e) => onButtonClick(e)} />
    </Flex>
  </CardStyle>
);
